/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OrganisationSettings
 */
export interface OrganisationSettings {
  /**
   *
   */
  readonly historicalRainRadarUuids?: Array<string>;
  /**
   *
   */
  readonly forecastRainRadarUuids?: Array<string>;
}

/**
 * Check if a given object implements the OrganisationSettings interface.
 */
export function instanceOfOrganisationSettings(value: object): value is OrganisationSettings {
  return true;
}

export function OrganisationSettingsFromJSON(json: any): OrganisationSettings {
  return OrganisationSettingsFromJSONTyped(json, false);
}

export function OrganisationSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OrganisationSettings {
  if (json == null) {
    return json;
  }
  return {
    historicalRainRadarUuids:
      json["historical_rain_radar_uuids"] == null ? undefined : json["historical_rain_radar_uuids"],
    forecastRainRadarUuids:
      json["forecast_rain_radar_uuids"] == null ? undefined : json["forecast_rain_radar_uuids"],
  };
}

export function OrganisationSettingsToJSON(json: any): OrganisationSettings {
  return OrganisationSettingsToJSONTyped(json, false);
}

export function OrganisationSettingsToJSONTyped(
  value?: Omit<OrganisationSettings, "historicalRainRadarUuids" | "forecastRainRadarUuids"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
